import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../lib/api';

interface User {
  id: string;
  email: string;
  name: string;
  tenantId: string;
  profile?: 'ADMIN' | 'DIRETOR' | 'GERENTE' | 'CORRETOR' | 'CAPTADOR';
  canDeleteCharges?: boolean;
}

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
  setUser: (user: User) => void;
  refreshUser: () => Promise<void>;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      login: async (email: string, password: string) => {
        const response = await api.post('/auth/login', { email, password });
        const { accessToken, user } = response.data;
        
        localStorage.setItem('access_token', accessToken);
        set({ token: accessToken, user, isAuthenticated: true });
      },

      logout: () => {
        localStorage.removeItem('access_token');
        set({ user: null, token: null, isAuthenticated: false });
      },

      setUser: (user: User) => set({ user }),

      // Atualiza as permissões do usuário a partir do backend (sem precisar relogar).
      refreshUser: async () => {
        try {
          const { data } = await api.get('/auth/me');
          set((state) => ({ user: state.user ? { ...state.user, ...data } : data }));
        } catch {
          /* mantém o usuário atual se falhar */
        }
      },
    }),
    {
      name: 'auth-storage',
    }
  )
);
